import * as React from 'react'
import { ToasterProvider, ToasterViewport } from 'Components/Elements/Toaster/Toaster.styled'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { Toast } from './Toast'

export const Toaster = () => {
  const { toasts, removeToast } = useAppStore()

  const handleRemoveToast = (id: string) => () => {
    removeToast(id)
  }

  return (
    <ToasterProvider swipeDirection="right">
      <ToasterViewport>
        {!!toasts &&
          toasts.map((toast) => {
            return (
              <Toast key={toast.id} type={toast.type} onClose={handleRemoveToast(toast.id)}>
                {toast.text}
              </Toast>
            )
          })}
      </ToasterViewport>
    </ToasterProvider>
  )
}
